import { isNativeApp, saveNativeImage } from 'common/webview';

/** 저장 결과 — 부르는 쪽이 안내 문구를 고릅니다 */
export type PhotoSaveResult =
    /** 사진첩에 넣었습니다 */
    | 'saved'
    /** 앱이 이 기능을 모릅니다(구버전) — 업데이트가 필요합니다 */
    | 'needsAppUpdate'
    /** 앱이 시도했지만 실패했습니다(권한 거부·네트워크 등) */
    | 'failed'
    /** 앱이 아니라 브라우저 — 새 탭으로 열어 사용자가 저장합니다 */
    | 'opened';

/**
 * 사진 한 장을 기기에 저장합니다.
 *
 * 웹에서 직접 할 수 없습니다 — CDN 이 CORS 를 열어 주지 않아 자바스크립트가
 * 이미지 바이트를 읽지 못합니다(실기기 확인). 그래서 앱에 맡깁니다.
 *
 * 브라우저에서는 새 탭으로 엽니다. 거기서 길게 눌러 저장하는 것이 브라우저의
 * 기본 동작이고, 우리가 더 해 줄 수 있는 것이 없습니다.
 */
export const savePhoto = async (url: string): Promise<PhotoSaveResult> => {
    if (!url) return 'failed';

    if (!isNativeApp()) {
        window.open(url, '_blank', 'noopener');
        return 'opened';
    }

    const res = await saveNativeImage(url);
    if (res.ok) return 'saved';
    if (res.timedOut) return 'needsAppUpdate';
    return 'failed';
};
